import { render, staticRenderFns } from "./budget-forms-list.vue?vue&type=template&id=a2be5136&"
import script from "./budget-forms-list.vue?vue&type=script&lang=ts&"
export * from "./budget-forms-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports